export default {"src":"/_next/static/media/engineering.c7becc73.svg","height":160,"width":160};